/**
 * Settings Page
 *
 * Hosts various application settings including notification preferences.
 */

import { useState } from 'react';
import { NotificationSettings } from '@/components/NotificationSettings';
import { DataExport } from '@/components/DataExport';

export function Settings(): JSX.Element {
  const [isSubscribed, setIsSubscribed] = useState(false);

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Notifications</h1>
        <p className="mt-2 text-sm text-gray-600">Manage your push notification preferences for auctions and governance</p>
      </div>

      <div className="max-w-3xl">
        <NotificationSettings onSubscriptionChange={setIsSubscribed} />
        <DataExport isSubscribed={isSubscribed} />
      </div>
    </div>
  );
}
